import { Button, Card, CardHeader, CardContent, Typography, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';

const styling = {
  buttonStyle: { height: '42px' },
};

interface FeatureSetupPage {
  openNoteDialog: () => void;
}

interface ComponentCell {
  openNoteDialog: () => void;
}

const ComponentCell = ({ openNoteDialog }: ComponentCell) => {
  return (
    <Grid container spacing={1}>
      <Grid item>
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_NOTE]}>
          <Button fullWidth variant="outlined" onClick={openNoteDialog} style={styling.buttonStyle}>
            NOTES
          </Button>
        </GuardedComponent>
      </Grid>
    </Grid>
  );
};

export const FeaturesSetup = ({ openNoteDialog }: FeatureSetupPage) => {
  return (
    <Card elevation={0}>
      <CardHeader
        className="subHead"
        title={
          <Typography variant="h3" color="textPrimary">
            SETUP
          </Typography>
        }
      ></CardHeader>
      <CardContent>
        <ComponentCell openNoteDialog={openNoteDialog} />
      </CardContent>
    </Card>
  );
};
